import { Column, GridApi, IHeaderParams } from "@ag-grid-community/core";
import { Badge, HStack, MenuItem } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { DataTableColumnMenuBase } from "shared/components/table/data/internal/DataTableColumnMenuBase";
import {
  ColumnSortState,
  useDataTableColumnSortProps,
} from "shared/components/table/data/internal/DataTableColumnSort";
import { DataTableColumnSortIndicator } from "shared/components/table/data/internal/DataTableColumnSortIndicator";
import { RowUngroupIcon } from "shared/icons/RowUngroupIcon";
import { SmallArrowDownIcon } from "shared/icons/SmallArrowDownIcon";
import { SmallCloseIcon } from "shared/icons/SmallCloseIcon";

export const DataTableAutoGroupColumnHeader: React.FC<IHeaderParams> = (
  params,
) => {
  const { api } = params;

  const { t } = useTranslation(["common"]);
  const rowGroupColumns = api.getRowGroupColumns();

  const { columnSort, onClickColumnSort } = useDataTableColumnSortProps(params);

  return (
    <HStack className="mb-header-cell-comp" onClick={onClickColumnSort}>
      <HStack display="inline-flex">
        <HStack divider={<SmallArrowDownIcon transform="rotate(-90deg)" />}>
          {rowGroupColumns.map((groupColumn) => (
            <GroupColumnBadge
              key={groupColumn.getColId()}
              api={api}
              groupColumn={groupColumn}
            />
          ))}
        </HStack>
        {columnSort && (
          <DataTableColumnSortIndicator state={columnSort as ColumnSortState} />
        )}
      </HStack>
      <DataTableColumnMenuBase>
        <MenuItem
          icon={<RowUngroupIcon />}
          onClick={() => {
            // a copy (slice) is needed because removeRowGroupColumns mutates the array
            const cols = api.getRowGroupColumns().slice();
            api.removeRowGroupColumns(cols);
          }}
        >
          {t("common:table.ungroupAll")}
        </MenuItem>
      </DataTableColumnMenuBase>
    </HStack>
  );
};

const GroupColumnBadge: React.FC<{
  api: GridApi;
  groupColumn: Column;
}> = ({ api, groupColumn }) => (
  <Badge
    variant="button"
    display="flex"
    alignItems="center"
    _hover={{
      "& .mb-icon-dismiss": {
        display: "flex",
      },
    }}
    onClickCapture={(event) => {
      event.stopPropagation();
      api.removeRowGroupColumns([groupColumn]);
    }}
  >
    {groupColumn.getColDef().headerName}
    <SmallCloseIcon
      className="mb-icon-dismiss"
      display="none"
      mr="-2px"
      color="gray.500"
    />
  </Badge>
);
